export default "__VITE_ASSET__ByuxeRay__"